import { DefaultUrlSerializer, Params, RouterStateSnapshot, UrlSegment } from '@angular/router';

import { RouterStateSerializer } from '@ngrx/router-store';

export interface IRouterStateUrl {
  url: string;
  params: Params;
  queryParams: Params;
}

export class CustomSerializer implements RouterStateSerializer<IRouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): IRouterStateUrl & { segments: Array<UrlSegment> } {
    let route = routerState.root;
    const segments = new DefaultUrlSerializer().parse(routerState.url).root.children['primary']?.segments ?? [];
    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    return { url, params, queryParams: queryParams, segments };
  }
}
